import axios from 'axios';
import ROUTES from '../api/routes';
import { TOKEN_CLIENT_LOCAL_STORAGE_NAME } from '../constants/constants';

export default function saveItemTask(taskData, id) {
  return (_, getStore) => {
    const { accessToken } = JSON.parse(localStorage.getItem(TOKEN_CLIENT_LOCAL_STORAGE_NAME)) || {};
    const { organizationId } = getStore().data;

    const data = JSON.stringify({
      ...taskData,
      buildingId: organizationId,
    });

    return axios.put(
      `${ROUTES.GET_TASKS}/${id}`,
      data,
      {
        headers: {
          accept: 'application/json',
          Authorization: accessToken,
          'content-type': 'application/json',
        },
      },
    )
      .catch((err) => err);
  };
}
